export default {
  name: 'loader',
  props: {
    isRequesting: {
      type: Boolean,
      default () { return false }
    },
    iconColor: {
      type: String,
      default () { return '#1e84e2' }
    },
    textLabel: {
      type: String,
      default () { return this.$t('label.loading') }
    },
    xs: {
      type: Boolean,
      default () { return false }
    },
    backgroundNoOpacity: {
      type: Boolean,
      default () { return false }
    }
  },
  data () {
    return {
      title: 'loader'
    }
  },
  methods: {},
  mounted () {}
}
